import * as React from 'react';
import { Filter, FilterOptionsContext, FormContext } from "../context/Form";
import { MultipleSelect } from "./MultipleSelect";
import { SegmentAverages } from "./SegmentAverages";

type SegmentProps = {
    filter: Filter;
    index: number;
    canDelete: boolean;
}

export const Segment = (props: SegmentProps): JSX.Element => {
    const [data, dispatch] = React.useContext(FormContext);
    const filteroptions = React.useContext(FilterOptionsContext);
    const [showBody, setShowBody] = React.useState(true);
    const [title, setTitle] = React.useState<string>(data.filter[props.index].title);

    const updateSegment = (value: Array<string>, filter: string): void => {
        const newData = {...data};
        newData.filter[props.index][filter] = value;
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    };

    const updateTitle = () => {
        const newData = {...data};
        newData.filter[props.index].title = title;
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    }

    const removeSegment = () => {
        const newData = {...data};
        newData.filter.splice(props.index, 1);
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    }

    const updateActive = (event: React.FormEvent): void => {
        const el: HTMLInputElement = event.target as HTMLInputElement;
        const newData = {...data};
        newData.filter[props.index].active = el.checked;
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    };

    let questionClasses = ['c-segments__segment__questions'];

    let segmentClasses = ['c-segments__segment'];
    if (showBody) {
        segmentClasses.push('c-segments__segment__body__active');
    }

    return <div className={segmentClasses.join(' ')}>
        <div className={'c-segments__segment__form'}>
            <div className={'c-segments__segment__meta'}>
                <input className={'form-control-check'} type={'checkbox'} checked={props.filter.active}
                       onChange={updateActive}/>
                <input className={'c-segments__segment__title'} type={'text'} value={title}
                       onChange={(event: React.FormEvent) => {
                           setTitle((event.target as HTMLInputElement).value);
                       }}
                       onBlur={updateTitle}/>
                <button className={'c-segments__toggle-segment'}
                        onClick={() => setShowBody(!showBody)}>Weergeven/Verbergen
                </button>
                {props.canDelete &&
                <button className={'c-segments__remove-segment'} onClick={removeSegment}>Verwijderen</button>}
            </div>
            <div className={'c-segments__segment__body'}>
                <div className={'c-segments__segment__filters'}>
                    <MultipleSelect
                        options={filteroptions.location}
                        updateSegment={(value) => updateSegment(value, 'location')}
                        value={props.filter.location}
                        label={'Locatie'}/>
                    <MultipleSelect
                        options={filteroptions.function}
                        updateSegment={(value) => updateSegment(value, 'function')}
                        value={props.filter.function}
                        label={'Functie'}/>
                    <MultipleSelect
                        options={filteroptions.age_group}
                        updateSegment={(value) => updateSegment(value, 'age_group')}
                        value={props.filter.age_group}
                        label={'Leeftijd'}/>
                    <MultipleSelect
                        options={filteroptions.educational_level}
                        updateSegment={(value) => updateSegment(value, 'educational_level')}
                        value={props.filter.educational_level}
                        label={'Opleiding'}/>
                </div>
            </div>
            {data.filter[props.index].active && <SegmentAverages filter_id={data.filter[props.index].id}/>}
        </div>
    </div>;
}
